import React from 'react';
import MultiButtonSwitch from '../common/editors/MultiButtonSwitch';
import { LocaleFlag } from './LocaleFlag';

const options = ['es', 'en', 'pt'].map(l => ({value: l, label: <LocaleFlag locale={l}/>}));

export function LocalesSelector({ value, onChange, multi = true }) {
  return <MultiButtonSwitch value={value} multi={multi} onChange={onChange} options={options}/>;
}
